module.exports = __webpack_public_path__ + "img/menu25.d61ee3bd.png";